<div class="contact-container">
    <h1>Contact Us</h1>
    
    <form (ngSubmit)="onSubmit()" #contactForm="ngForm" class="contact-form">
      
      <!-- Name -->
      <div class="form-group">
        <label for="name">Name</label>
        <input type="text" id="name" name="name" class="form-control" [(ngModel)]="contact.name" required />
      </div>
  
      <!-- Email -->
      <div class="form-group">
        <label for="email">Email</label>
        <input type="email" id="email" name="email" class="form-control" [(ngModel)]="contact.email" required />
      </div>
  
      <!-- Subject -->
      <div class="form-group">
        <label for="subject">Subject</label>
        <input type="text" id="subject" name="subject" class="form-control" [(ngModel)]="contact.subject" required />
      </div>
  
      <!-- Message -->
      <div class="form-group">
        <label for="message">Message</label>
        <textarea id="message" name="message" class="form-control" rows="5" [(ngModel)]="contact.message" required></textarea>
      </div>
  
      <!-- Submit Button -->
      <button type="submit" class="btn btn-primary" [disabled]="!contactForm.form.valid">Send Message</button>
  
    </form>
    
    <!-- Success Message -->
    <div *ngIf="submitted" class="success-message">
      Thank you for contacting us! We'll get back to you shortly.
    </div>
  </div>
  